import { ENV } from "../utils";

export class Cv {
  baseApi = ENV.BASE_API;

  async createCv(data) {
    try {
      const formData = new FormData();

      const fieldMap = {
        nombre: "nombre",
        apellido: "apellido",
        documento_identidad: "documento_identidad",
        correo_electronico: "correo_electronico",
        telefono: "telefono1",
        movil: "telefono2",
        genero: "genero",
        estado_civil: "estado_civil",
        fecha_nacimiento: "fecha_nacimiento",
        licencia_conducir: "licencia_tiene",
        categoria_licencia: "categoria_licencia",
        tiene_vehiculo: "vehiculo_propio",
        direccion: "direccion",
        sector_barrio: "sector_barrio",
        ciudad: "ciudad",
        // Redes sociales
        linkedin:  "linkedin",
        facebook:  "facebook",
        instagram: "instagram",
        twitter:   "twitter",
        github:    "github",
        tiktok:    "tiktok",
      };

      Object.entries(fieldMap).forEach(([formKey, docKey]) => {
        const value = data[formKey];
        if (value !== undefined && value !== null && value !== "") {
          formData.append(docKey, value);
        }
      });

      formData.append("accion", "nuevo");
      formData.append("area_interes", data.area_interes || "");
      formData.append("academica", "[]");
      formData.append("experiencia", "[]");
      formData.append("familia", "[]");
      formData.append("herramienta_office", "[]");

      if (data.fileCv) {
        formData.append("fileDocument", data.fileCv);
      }

      const url = `${this.baseApi}/documento`;
      const params = {
        method: "POST",
        headers: {},
        body: formData,
      };

      const response = await fetch(url, params);
      const result = await response.json();

      if (response.status !== 201) throw result;

      return result;
    } catch (error) {
      throw error;
    }
  }

  async validarDocumento(data) {
    const url = `${this.baseApi}/documento/validar`;

    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };

    return fetch(url, params)
      .then((response) => response.json())
      .then((result) => result)
      .catch((err) => err.message);
  }
}
